import EditingContext from '@/store/editingContext'
import { ProfileType, UserProfile } from '@/types/api'
import { CallbackWrap } from '@/types/common'
import Accordion from '@/ui/accordion'
import classNames from 'classnames'
import React, { ReactNode } from 'react'
import ProfilesSection from './Profiles'
import SaveSection from './Save'

import './ImportPane.scss'

function ImportPaneSection({
  title,
  children,
  expandKey,
  expanded,
  setExpanded
}: {
  title: string
  children: ReactNode
  expandKey: string
  expanded: string | undefined
  setExpanded: (value: CallbackWrap<string | undefined>) => void
}) {
  const onClick = React.useCallback(
    () => setExpanded((prev) => (prev === expandKey ? undefined : expandKey)),
    [setExpanded, expandKey]
  )
  return (
    <div
      className={classNames('poe-Section', {
        'poe-expanded': expanded === expandKey
      })}>
      <h3 onClick={onClick}>{title}</h3>
      <Accordion visible={expanded === expandKey} timing="ease-in-out">
        {children}
      </Accordion>
    </div>
  )
}

export function defaultFilter(profile: UserProfile, type: ProfileType) {
  if (profile.type === type) return true
  if (type === 'planner') {
    if (!profile.type || profile.type === 'embed' || profile.type === 'atlas-tree' || profile.type === 'passive-tree') {
      return true
    }
  }
  if (type === 'planner' || type === 'pob') return false
  if (!profile.type) return true
  if (type === 'atlas-tree' || type === 'passive-tree') {
    return profile.type === 'atlas-tree' || profile.type === 'passive-tree'
  } else {
    return profile.type === 'embed'
  }
}

export default React.memo(function ImportPane({
  type,
  filter = (profile) => defaultFilter(profile, type)
}: {
  type: ProfileType
  filter?: (profile: UserProfile) => any
}) {
  const [expanded, setExpanded] = EditingContext.useState('importSection')

  return (
    <>
      <div className="poe-TabContent poe-ImportPane">
        <ImportPaneSection title={`Save`} expandKey="save" expanded={expanded} setExpanded={setExpanded}>
          <SaveSection type={type} />
        </ImportPaneSection>
        <ImportPaneSection title={`My Profiles`} expandKey="profiles" expanded={expanded} setExpanded={setExpanded}>
          <ProfilesSection type={type} filter={filter} />
        </ImportPaneSection>
      </div>
    </>
  )
})
